export default "__VITE_PUBLIC_ASSET__2b06bd6f__"